<template>
    <div class="app-inner">
        <div class="searchTitleDiv">
            <div class="stateDiv">
                <p class="searchText">状态</p>
                <el-select v-model="searchFrom.status" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="stateDiv">
                <p class="searchText">假期类型</p>
                <el-select v-model="searchFrom.leaveType" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in datTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="stateDiv">
                <p class="searchText">编码</p>
                <el-input v-model="searchFrom.eventId" clearable placeholder="请输入" style="width:220px"></el-input>
            </div>
            <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
            <el-button class="searchBtn" type="warning" @click="addFormData">申请</el-button>
        </div>
        <!--      列表-->
        <div class="table">
            <div class="searchList">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="我的请假申请" name="mine"></el-tab-pane>
                    <!-- <el-tab-pane label="待我审批" name="approve"></el-tab-pane> -->
                    <el-tab-pane label="待我审批" name="approve">
                        <div slot="label">
                            待我审批
                            <el-badge :value='workNumber' style="margin-bottom:20px"></el-badge>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="已审批" name="finishApproval"></el-tab-pane>
                </el-tabs>
                <TableList :data="tableData" :columnDefs="tableColumns" :total="totalCount"
                    @pageChange="handleCurrentChange">
                    <template #action="{ row, index }" class="tableButton">
                        <!-- <el-button class="tableBtn" @click="viewOrHandle(row, 'edit')" type="text" size="small">编辑
                        </el-button> -->
                        <el-button type="text" size="small" v-if="row.status === 1 && activeName == 'mine'" @click="exportDetails(row.id)">导出审批单</el-button>
                        <el-button class="tableBtn" @click="viewOrHandle(row, 'view')" type="text" size="small">查看详情
                        </el-button>
                        <el-button class="tableBtn" @click="approval(row, 'view')"
                            v-if="row.status == 0 && activeName == 'mine'" type="text" size="small">催批
                        </el-button>
                        <el-button class="tableBtn" @click="viewOrHandle(row, 'update')"
                            v-if="(row.status == 2 || row.status == 10) && activeName == 'mine'" type="text" size="small">修改
                        </el-button>
                        <!-- <el-button class="tableBtn" @click="deleteFun(row)" type="text" size="small">删除</el-button> -->
                    </template>
                </TableList>
            </div>
        </div>
        <!--    新增/编辑弹框-->
        <div class="dialogDiv">
            <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeData" center>
                <el-form ref="addForm" :model="addForm" :rules="rules" label-width="150px">
                    <el-row v-if="eventControlType !== 'add'">
                        <el-form-item label="编号" prop="eventId" class="formItem">
                            <el-input v-model="addForm.eventId" clearable placeholder="请输入" disabled />
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="假期类型" prop="leaveType" class="formItem">
                            <el-select v-model="addForm.leaveType" placeholder="请选择" class="inputDiv" clearable
                                style="width:100%" :disabled="eventControlType !== 'add'" @change="handleLeaveType">
                                <el-option v-for="item in datTypeOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="开始时间" prop="begin" class="formItem">
                            <el-date-picker v-model="addForm.begin" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                @change="beginTime" placeholder="选择日期时间" style="width:100%"
                                :disabled="eventControlType !== 'add'">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="结束时间" prop="end" class="formItem">
                            <el-date-picker v-model="addForm.end" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                @change="endTime" placeholder="选择日期时间" style="width:100%"
                                :disabled="eventControlType !== 'add'">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="时长" prop="dayCount" class="formItem" style="margin-bottom: 0;">
                            <el-input-number v-model="addForm.dayCount" :min="0.5" :max="100" placeholder="大于等于0.5"
                                style="width:90%;margin-right:5px" :controls="false"
                                :disabled="eventControlType !== 'add'"></el-input-number>天
                        </el-form-item>
                        <el-form-item style="height:20px"><span style="color:red">时长大于3天需董事长审批</span></el-form-item>
                    </el-row>
                    <el-row v-if="addForm.leaveType == '年假'" style="margin-bottom:20px">
                        <el-form-item label="当前剩余年假" prop="dayCount" class="formItem" style="margin-bottom: 0;">
                            <el-input-number v-model="vacationCount" :min="0" :max="100" placeholder="大于等于0.5"
                                :controls="false" style="width:90%;margin-right:5px" disabled></el-input-number>天
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="申请事由" prop="applyReason" class="formItem">
                            <el-input type="textarea" v-model="addForm.applyReason" clearable placeholder="请输入"
                                :disabled="eventControlType !== 'add'" maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row v-if="activeNameNew == 'approve'">
                        <el-form-item label="审核状态" prop="status" class="formItem" v-if="addForm.approvalFlag">
                            <el-select style="width:100%" v-model="addForm.status" placeholder="请选择" class="inputDiv"
                                clearable @change="handleRemark">
                                <el-option :value="item.value" :label="item.label" v-for="(item, index) in statusOptions1"
                                    :key="index" />
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row v-if="activeNameNew == 'approve'">
                        <!-- addForm.approvalFlag && addForm.status == '2' -->
                        <el-form-item label="审核原因" class="formItem" v-if="addForm.approvalFlag">
                            <el-input type="textarea" v-model="addForm.remark" clearable placeholder="请输入" maxlength="500"
                                show-word-limit @input="changeMessage($event)"></el-input>
                        </el-form-item>
                    </el-row>
                    <template v-if="eventControlType === 'add' || addForm.status === 0">
                        <approvalRadio  v-model="isSubmitApproval"/>
                        <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeNameNew == 'mine'">
                            <el-select v-model="addForm.auditPersonId" style="width:100%" placeholder="请选择" clearable
                                filterable :disabled="eventControlType === 'edit'">
                                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName"
                                    :value="item.userName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <template v-if="activeNameNew == 'approve'">

                        <approvalRadio  v-model="isSubmitApproval" v-show="addForm.status == '3'"/>

                        <el-form-item label="转办人" prop="nextAuditUserName" v-if="addForm.status == '3'">
                            <el-select v-model="addForm.nextAuditUserName" style="width:100%" placeholder="请选择" clearable
                                filterable>
                                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName"
                                    :value="item.userName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <template v-if="activeNameNew == 'approve'">
                        <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="addForm.status == '1'">
                            <el-radio v-model="addForm.lastUserFlag" :label="1">是</el-radio>
                            <el-radio v-model="addForm.lastUserFlag" :label="0">否</el-radio>
                        </el-form-item>

                        <approvalRadio  v-model="isSubmitApproval" v-show="addForm.status == '1' && addForm.lastUserFlag == 0"/>

                        <el-form-item label="下一级审核人" prop="nextAuditUserName"
                            v-if="addForm.status == '1' && addForm.lastUserFlag == 0">
                            <el-select style="width:100%" v-model="addForm.nextAuditUserName" placeholder="请选择" clearable
                                filterable>
                                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName"
                                    :value="item.userName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <el-row>
                        <review-process :processList="addForm.auditProcessEntityList" :createTime="addForm.createTime"
                            :createUser="addForm.applyUser" :auditPerson="addForm.auditPerson" />
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitArrroval()" v-if="addForm.approvalFlag && eventControl !== '查看详情'">提 交</el-button>
                    <el-button type="primary" @click="addEventForm()" v-if="eventControlType == 'add'">提 交</el-button>
                    <el-button type="primary" @click="saveEventForm()"
                        v-if="(eventControlType === 'add' && addForm.status === 10) || (eventControlType === 'add' && addForm.status === '')">暂
                        存</el-button>
                    <el-button @click="closeData">取 消</el-button>
                </div>
            </el-dialog>
        </div>
        <download ref="Download"/>
    </div>
</template>

<script>
import { compApplyLeave } from '@/api/comprehensive'
// import { validPassword } from '@/assets/scripts/validate'
import { Message } from 'element-ui'
import TableList from '@/components/TableList'
import ReviewProcess from '@/components/ReviewProcess.vue'
// import { queryUserInfo } from '@/api/basicInfo'
import approval from '@/mixins/approval'
import Download from './download.vue'
export default {
    mixins: [approval],
    name: 'accountPage',
    components: {
        TableList,
        ReviewProcess,
        Download
    },
    data() {
        return {
            loading: false,
            searchFrom: {
                leaveType: '', // 假期类型
                status: '', // 假期类型
            },
            activeName: 'mine',
            activeNameNew: 'mine',
            currentPage: 1,
            totalCount: 0,
            workNumber: 0,
            pageSize: 10,
            dialogFormVisible: false,
            eventControl: '',
            eventControlType: '',
            actionType: '',
            edit: false,
            passwordForm: {},
            vacationCount: 0,
            addForm: {
                leaveType: '', // 假期类型
                applyReason: '', // 申请原因
                begin: '', // 使用开始时间
                end: '', // 使用结束时间
                dayCount: '', // 请假时长
                createTime: '',
                applyUser: '',
                auditProcessEntityList: [],
                status: '',
                eventId: '',
                lastUserFlag: '',
                nextAuditUserName: '',
                auditPersonId: '',
            },
            statusOptions1: [
                {
                    value: '1',
                    label: '通过'
                },
                {
                    value: '2',
                    label: '拒绝'
                },
                {
                    value: '3',
                    label: '转办'
                },
                {
                    value: '4',
                    label: '退回上一级'
                },
            ],
            rules: {
                leaveType: [{ required: true, message: '请选择', trigger: 'change' }],
                begin: [{ required: true, message: '请选择', trigger: 'blur' }],
                end: [{ required: true, message: '请选择', trigger: 'blur' }],
                dayCount: [{ required: true, message: '请填写', trigger: 'blur' }],
                remark: [{ required: true, message: '请填写', trigger: 'blur' }],
                status: [{ required: true, message: '请选择', trigger: 'blur' }],
                applyReason: [{ required: true, message: '请填写', trigger: 'blur' }],
                nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
                auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
                lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
            },
            tableData: [],
            // userInfoList: [],
            statusOptions: [
                {
                    label: '待审核',
                    value: 0
                },
                {
                    label: '已通过',
                    value: 1
                },
                {
                    label: '已拒绝',
                    value: 2
                },
                {
                    label: '暂存',
                    value: 10
                },
            ],
            datTypeOptions: [
                {
                    label: '事假',
                    value: '事假'
                },
                {
                    label: '婚假',
                    value: '婚假'
                },
                {
                    label: '病假',
                    value: '病假'
                },
                {
                    label: '丧假',
                    value: '丧假'
                },
                {
                    label: '产假',
                    value: '产假'
                },
                {
                    label: '陪产假',
                    value: '陪产假'
                },
                {
                    label: '年假',
                    value: '年假'
                },
                {
                    label: '调休',
                    value: '调休'
                },
                {
                    label: '出省报备',
                    value: '出省报备'
                }
            ],
            tableColumns: [
                {
                    label: '编号',
                    prop: 'eventId'
                },
                {
                    prop: 'applyUser',
                    label: '申请人'
                },
                {
                    prop: 'auditPerson',
                    label: '审核人',
                    formatter: (row, column, v) => {
                        return row.auditPerson !== '' ? row.auditPerson : row.preAuditPerson
                    }
                },
                {
                    prop: 'begin',
                    label: '开始时间'
                },
                {
                    prop: 'end',
                    label: '结束时间'
                },
                {
                    prop: 'status',
                    label: '状态',
                    formatter: (row, column, v) => {
                        return (this.statusOptions.find(v => v.value === row.status)).label
                    }
                },
                {
                    prop: 'leaveType',
                    label: '假期类型'
                },
                {
                    prop: 'dayCount',
                    label: '请假时长(天)'
                },
                // {
                //   prop: 'status',
                //   label: '状态',
                //   formatter: (row, column, v) => {
                //     return row.status === 1 ? '已查看' : '未查看'
                //   }
                // },
                {
                    minWidth: '230',
                    prop: 'action',
                    label: '操作',
                },
            ]
        }
    },
    mounted() {
        this.getData()
        this.queryList()
    },
    methods: {
        // 导出审批单
        async exportDetails (id) {
            // await update({ exportFlag: true, id: id })
            await this.getData()
            this.$refs.Download.getDetails(id)
        },

        handleStatus(creatUser) {
            let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
            if (userName === creatUser) {
                this.statusOptions1 = [
                    {
                        value: '1',
                        label: '通过'
                    },
                    {
                        value: '2',
                        label: '拒绝'
                    },
                    {
                        value: '3',
                        label: '转办'
                    },
                ]
            }
        },
        handleRemark(val) {
            if (val === '1') {
                this.addForm.remark = '同意'
            } else if (val === '3') {
                this.addForm.remark = '转办'
            } else {
                this.addForm.remark = ''
            }
        },
        // 强制更新测试文本信息框的值
        changeMessage() {
            this.$forceUpdate()
        },
        // async queryUser() {
        //     let res = await queryUserInfo({
        //         pageNum: 1,
        //         pageSize: 9999,
        //     })
        //     if (res.code === 0) {
        //         this.userInfoList = res.result.records
        //     }
        // },
        async handleLeaveType(value) {
            console.log(value);
            if (value !== '年假') {
                return
            }
            let res = await compApplyLeave('getLeftVacation')
            this.vacationCount = res.result
        },
        handleClick(val) {
            this.activeName = val.name
            this.activeNameNew = val.name
            this.queryDataList()
        },
        handleFile(imgs) {
            let arrFile = imgs.map(v => v.name).join(',')
            this.addForm.fileUrlList = arrFile
        },
        getData() {
            this.currentPage = 1
            this.queryDataList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.queryDataList()
        },
        async queryDataList() {
            let res = await compApplyLeave(this.activeName === 'mine' ? 'queryMine' : this.activeName === 'approve' ? 'queryMyAudit' : 'listApplyAudited', {
                ...this.searchFrom,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            })
            if (res.code === 0) {
                this.tableData = res.result.records
                this.totalCount = res.result.total
                this.getNum()
            }
        },
        async getNum() {
            let res = await compApplyLeave('queryMyAudit', {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            })
            if (res.code === 0) {
                this.workNumber = res.result.total
            }
        },
        addFormData() {
            this.eventControlType = 'add'
            this.actionType = 'add'
            this.dialogFormVisible = true
            this.eventControl = '请假申请'
            this.activeNameNew = 'mine'
        },
        async viewOrHandle(row, type) {
            console.log(row);
            this.activeNameNew = this.activeName
            if (type === 'view') {
                this.eventControlType = 'edit'
            } else {
                this.eventControlType = 'add'
            }
            this.eventControl = this.activeName === 'mine' ? '查看详情' : '待审批'
            // this.newOldFormContrast(row)
            const { code, result } = await compApplyLeave('getApplyDetail', {
                id: row.id,
                // id: 3,
            })
            if (code === 0) {
                this.addForm = {
                    auditPerson: row.auditPerson,
                    leaveType: row.leaveType, // 假期类型
                    begin: row.begin, // 使用开始时间
                    end: row.end, // 使用结束时间
                    dayCount: row.dayCount, // 加班时长
                    applyReason: row.applyReason, // 申请原因
                    eventId: row.eventId,
                    id: row.id,
                    createTime: result.createTime,
                    applyUser: result.applyUser,
                    approvalFlag: result.approvalFlag,
                    auditProcessEntityList: result.auditProcessEntityList,
                    lastUserFlag: result.lastUserFlag,
                    nextAuditUserName: result.nextAuditUserName,
                    auditPersonId: result.auditPersonId,
                    status: result.approvalFlag === true ? '' : result.status,
                }
                this.handleStatus(result.createUser)
            }
            this.dialogFormVisible = true
        },
        newOldFormContrast(newForm) {
            Object.keys(this.addForm).forEach(key => {
                this.addForm[key] = newForm[key]
            })
            this.addForm.id = newForm.id
        },
        closeData() {
            this.dialogFormVisible = false
            this.$refs['addForm'].resetFields()
            this.addForm = this.$options.data.call(this).addForm
        },
        submitArrroval() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let res = await compApplyLeave('auditAndNextUser', {
                        id: this.addForm.id,
                        remark: this.addForm.remark,
                        status: this.addForm.status,
                        lastUserFlag: this.addForm.lastUserFlag,
                        nextAuditUserName: this.addForm.nextAuditUserName,
                    })
                    if (res.code === 0) {
                        Message.success('审批成功！')
                        this.closeData()
                        await this.getData()
                    } else {
                        Message.warning({ message: res.message })
                    }
                }
            })
        },
        addEventForm() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let res = await compApplyLeave('submitApply', {
                        leaveType: this.addForm.leaveType, // 假期类型
                        applyReason: this.addForm.applyReason, // 申请原因
                        begin: this.addForm.begin, // 使用开始时间
                        end: this.addForm.end, // 使用结束时间
                        dayCount: this.addForm.dayCount, // 请假时长
                        auditPersonId: this.addForm.auditPersonId,
                        eventId: this.addForm.eventId,
                        id: this.addForm.id
                    })
                    if (res.code === 0) {
                        Message.success('新增成功！')
                        this.closeData()
                        await this.getData()
                    } else {
                        Message.error(res.message)
                    }
                }
            })
        },
        // 暂存
        saveEventForm() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let res = await compApplyLeave('stagingApply', {
                        leaveType: this.addForm.leaveType, // 假期类型
                        applyReason: this.addForm.applyReason, // 申请原因
                        begin: this.addForm.begin, // 使用开始时间
                        end: this.addForm.end, // 使用结束时间
                        dayCount: this.addForm.dayCount, // 请假时长
                        auditPersonId: this.addForm.auditPersonId,
                        eventId: this.addForm.eventId
                    })
                    if (res.code === 0) {
                        Message.success('暂存成功！')
                        this.closeData()
                        await this.getData()
                    } else {
                        Message.error(res.message)
                    }
                }
            })
        },
        async approval(row) {
            this.$confirm('此操作将进行催批, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let params = {
                    'id': row.id
                }
                let res = await compApplyLeave('sendSmsAuditPersonAgain', params)
                if (res.code === 0) {
                    this.$message({ type: 'success', message: '催批成功!' })
                }
                await this.getData()
            })
        },
        beginTime() {
            if (this.addForm.end) {
                if (this.addForm.begin > this.addForm.end) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message.warning('开始时间不能大于结束时间')
                    }
                    this.addForm.begin = ''
                }
            }
        },
        endTime() {
            if (this.addForm.begin) {
                if (this.addForm.end < this.addForm.begin) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message.warning('结束时间不能小于开始时间')
                    }
                    this.addForm.end = ''
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
}

.searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;
    /*display: flex;*/
    /*justify-content: space-around;*/

    .stateDiv {
        margin-top: 0.14rem;
        margin-left: .3rem;
        float: left;
    }

    .searchText {
        margin-top: 0.05rem;
        margin-right: 0.13rem;
        font-size: 0.2rem;
        color: #606266;
        float: left;
    }

    .inputDiv {
        width: 2.2rem;
        float: left;
    }

    .searchBtn {
        /*width: 1.20rem;*/
        /*height: 0.36rem;*/
        /*border-radius: 0.06rem;*/
        /*font-size: 0.18rem;*/
        margin-top: 0.14rem;
        margin-left: .3rem;
        /*padding-top: 0.1rem;*/
    }
}

.table {
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;

    .searchList {}

    .paginationBody {
        margin-top: .1rem;
    }
}

.formItem {
    // width: 3.2rem;
}

/deep/ .el-dialog {
    width: 30% !important;
}</style>
